import React, { ChangeEvent } from 'react';

interface Props {
  id: string;
  value: string;
  error?: string | null;
  required?: boolean;
  options: Array<{ key: string; value: string } | string>;
  label?: string;
  noLable?: boolean;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  onClick?: () => void;
}

interface OptionProps {
  data: { key: string; value: string } | string;
}

const Option = ({ data }: OptionProps) => {
  if (typeof data === 'object') {
    return <option value={data.key}>{data.value}</option>;
  }
  if (typeof data === 'string') {
    return <option value={data}>{data}</option>;
  }
  return <></>;
};

const Select = ({
  id,
  error,
  required,
  value,
  options,
  label,
  noLable,
  onChange,
  onClick
}: Props) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    onChange(e);
  };
  return (
    <div id="operation_selectError" className={`${error ? 'border-2 border-[#e60014]' : ''}`}>
      <select
        id={id}
        value={value}
        className="sm:w-52 lg:w-60 flex-grow w-full bg-[url('https://my.bt.com/s/apps/appsconnectedcare/img/br_down.png')] bg-right bg-size-32 border border-light-gray px-4 py-2 rounded-md bg-no-repeat overflow-hidden appearance-none"
        onChange={handleChange}
        onClick={onClick}
        required={required}
      >
        {!noLable && <option value="" label={label ?? 'Select'} />}
        {options.length && options.map((item, index) => <Option key={index} data={item} />)}
      </select>
    </div>
  );
};

export default Select;
